import { CustomDialog } from "../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { SellertoolSignatureUtils } from "../../../../../utils/sellertool-signature-utils";
import { useApiInfoContextValueHook } from "../../../../../contexts/ApiInfoContextProvider";
import { CustomBackdropController } from "../../../../../components/backdrop/default/v1";
import axios from "axios";
import { customToast } from "../../../../../components/toast/custom-react-toastify/v1";
import { useEffect, useState } from "react";
import { CustomDateUtils } from "../../../../../utils/custom-date-utils";
import CustomBlockButton from "../../../../../components/button/CustomBlockButton";

const StyledBody = styled.div`
    padding: 10px;    
`;

const StyledContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;

    @media all and (max-width:992px){
        flex-direction: column;
    }
`;

const StyledBackupItemList = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid #e0e0e0;
    min-width: 250px;
    height: 300px;
    overflow-y: auto;
    border-radius: 5px;

    .item{
        position: relative;
        padding: 10px;
        font-size: 14px;

        &.selected{
            background-color: #f0f0f0;
        }
    }

    .prev-badge{
        background-color: #f0f0f0;
        padding: 2px 5px;
        border-radius: 3px;
        font-size: 12px;
        color: #666;
    }
`;

const StyledRackLocationItemList = styled.div`
    border: 1px solid #e0e0e0;
    flex: 1;
    border-radius: 5px;
`;

const StyledTableContainer = styled.div`
    width: 100%;
    height: 300px;
    overflow: auto;
    background: white;
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #e2e8f0;
`

const StyledTable = styled.table`
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
`

const StyledTableColumnGroup = styled.colgroup`
    .col-1, .col-2, .col-3 { width: 200px; }
    .col-4, .col-5 { width: 130px; }
`

const StyledTableHeader = styled.thead`
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f8fafc;
`

const StyledTableHeaderRow = styled.tr`
    &:first-child {
        th {
            padding: 12px 10px;
            font-size: 13px;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            border-bottom: 1px solid #e2e8f0;
            background-color: #f1f5f9;
        }
    }

    &:last-child {
        th {
            padding: 10px 10px;
            font-size: 12px;
            border-bottom: 2px solid #cbd5e0;
            background-color: #f8fafc;
        }
    }
`

const StyledTableHeaderCell = styled.th`
    text-align: left;
    color: #334155;
    font-weight: 600;
`

const StyledTableBody = styled.tbody`
    /* Custom styling for table body */
`

const StyledTableRow = styled.tr`
    transition: background-color 0.2s;

    &:hover {
        background-color: #f1f5f9;
    }
`

const StyledTableCell = styled.td`
    padding: 10px 10px;
    border-bottom: 1px solid #e2e8f0;
    color: #334155;
    font-size: 12px;
    line-height: 1.5;

    &.bold {
        font-weight: 700;
    }

    &.handlerCell {
        display: flex;
        align-items: center;   
        gap: 8px;
    }
    
    mark {
        background-color: #fef08a;
        padding: 1px 2px;
        border-radius: 2px;
    }
`

const StyledFooterButtonField = styled.div`
    margin-top: 10px;

    p{
        font-size: 14px;
        color: var(--redColor1);
        font-weight: 700;
        margin-bottom: 10px;
    }
    button{
        background: #333;
        color:#fff;
    }
`;

const API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function WegetBackupModal({
    open,
    onClose,
    targetRackLocation,
    onReqFetchRackLocations
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [backupRackLocations, setBackupRackLocations] = useState(null);
    const [selectedBackupRackLocation, setSelectedBackupRackLocation] = useState(null);

    useEffect(() => {
        handleReqFetchBackupRackLocations();
    }, []);

    const handleReqFetchBackupRackLocations = async () => {
        const timestamp = Date.now().toString()
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp,
        })

        const headers = {
            "x-sellertool-apiKey": apiInfoContextValueHook?.apiInfo?.apiKey,
            "x-sellertool-timestamp": timestamp,
            "x-sellertool-signiture": signature,
        }

        CustomBackdropController().showBackdrop()
        const fetchResult = await axios
            .get(`${API_HOST}/backup-rack-locations/rack-locations/${targetRackLocation?._id}/list`, {
                headers: headers,
            })
            .then((res) => {
                return {
                    res: res,
                    content: res.data?.content,
                }
            })
            .catch((err) => {
                customToast.error(err.response)
            })

        if (fetchResult?.content) {
            setBackupRackLocations(fetchResult.content);
        }
        CustomBackdropController().hideBackdrop()
    }

    const handleSelect = (backupRackLocation) => {
        if (selectedBackupRackLocation?._id === backupRackLocation?._id) {
            setSelectedBackupRackLocation(null);
        } else {
            setSelectedBackupRackLocation(backupRackLocation);
        }
    }

    const handleReqRunBackup = async () => {
        if (!selectedBackupRackLocation) {
            customToast.error("백업을 선택해주세요.");
            return;
        }

        const timestamp = Date.now().toString()
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp,
        })

        const headers = {
            "x-sellertool-apiKey": apiInfoContextValueHook?.apiInfo?.apiKey,
            "x-sellertool-timestamp": timestamp,
            "x-sellertool-signiture": signature,
        }

        CustomBackdropController().showBackdrop()
        const fetchResult = await axios
            .post(`${API_HOST}/backup-rack-locations/run-backup`, {
                payload: selectedBackupRackLocation
            }, {
                headers: headers,
            })
            .then((res) => {
                return {
                    res: res,
                    content: res.data?.content,
                }
            })
            .catch((err) => {
                customToast.error(err.response)
            })

        if (fetchResult?.content) {
            customToast.success("백업이 완료되었습니다.");
            onReqFetchRackLocations();
            onClose();
        }
        CustomBackdropController().hideBackdrop()
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
                maxWidth="lg"
            >
                <CustomDialog.Header style={{ padding: '10px' }}>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>백업</CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => onClose()}></CustomDialog.Header.Close>
                </CustomDialog.Header>
                <StyledBody>
                    <StyledContentWrapper>
                        {backupRackLocations && backupRackLocations.length > 0 ? (
                            <>
                                <div>
                                    <StyledBackupItemList>
                                        {backupRackLocations.map((backupRackLocation) => {
                                            const isPrevious = backupRackLocation?._id === targetRackLocation?.prevBackupRackLocationId;
                                            return (
                                                <div
                                                    key={backupRackLocation?._id}
                                                    className={`item ${selectedBackupRackLocation?._id === backupRackLocation?._id ? 'selected' : ''}`}
                                                    onClick={() => handleSelect(backupRackLocation)}
                                                >
                                                    <div>생성일: {CustomDateUtils().formatDateToYYYYMMDD_HHmmss(backupRackLocation?.createdAt)}</div>
                                                    <div>
                                                        <div>상품개수: {backupRackLocation?.rackLocation?.items?.length || 0}</div>
                                                        {isPrevious && <span className='prev-badge'>PREV</span>}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </StyledBackupItemList>
                                </div>
                            </>
                        ) : (
                            <p>백업 로케이션이 없습니다.</p>
                        )}
                        {selectedBackupRackLocation &&
                            <>
                                <StyledTableContainer>
                                    <StyledTable>
                                        <StyledTableHeader>
                                            <StyledTableColumnGroup>
                                                <col className="col-1" />
                                                <col className="col-2" />
                                                <col className="col-3" />
                                                <col className="col-4" />
                                                <col className="col-5" />
                                            </StyledTableColumnGroup>
                                            <StyledTableHeaderRow>
                                                <StyledTableHeaderCell>상품명</StyledTableHeaderCell>
                                                <StyledTableHeaderCell>옵션명</StyledTableHeaderCell>
                                                <StyledTableHeaderCell>옵션코드</StyledTableHeaderCell>
                                                <StyledTableHeaderCell>수량</StyledTableHeaderCell>
                                                <StyledTableHeaderCell>BOX</StyledTableHeaderCell>
                                            </StyledTableHeaderRow>
                                        </StyledTableHeader>
                                        <StyledTableBody>
                                            {selectedBackupRackLocation?.rackLocation?.items.map((item) => (
                                                <StyledTableRow key={item?.uuid}>
                                                    <StyledTableCell>{item?.productName}</StyledTableCell>
                                                    <StyledTableCell>{item?.optionName}</StyledTableCell>
                                                    <StyledTableCell>{item?.optionCode}</StyledTableCell>
                                                    <StyledTableCell>{item?.productQuantity}</StyledTableCell>
                                                    <StyledTableCell>{item?.boxQuantity}</StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </StyledTableBody>
                                    </StyledTable>
                                </StyledTableContainer>
                            </>
                        }
                    </StyledContentWrapper>
                    <StyledFooterButtonField>
                        <p>* 백업 실행시 현재 상태는 완전히 잃게 됩니다.</p>
                        <CustomBlockButton
                            type='button'
                            onClick={() => handleReqRunBackup()}

                        >
                            백업 실행
                        </CustomBlockButton>
                    </StyledFooterButtonField>
                </StyledBody>
            </CustomDialog>
        </>
    );
}